import Dialog from "@material-ui/core/Dialog";
import {Box} from "@material-ui/core";
import * as React from "react";
import {withStyles} from "@material-ui/core/styles";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import {useAuthDispatcher} from "../../context/AuthContext";

import {actionTypes} from "../../context/reducer"
import {RouteInfo} from "../../route/RouteHelper";
import {useNavigate} from "react-router-dom";
import {removeUserRefreshToken, removeUserToken} from "../../service/localStorage/LocalStorageService";

const Exit = ({openDialog,setOpenDialog, handleClickOpen, handleClose}) => {

    const navigate = useNavigate()
    const dispatch = useAuthDispatcher()

    // LogOut-end
    const styles = (theme) => ({
        root: {
            margin: 0,
            padding: theme.spacing(2),
        },
        closeButton: {
            position: 'absolute',
            right: theme.spacing(1),
            top: theme.spacing(1),
            color: theme.palette.grey[500],
        },
    });
    const DialogTitle = withStyles(styles)((props) => {
        const {children, classes, onClose, ...other} = props;
        return (
            <MuiDialogTitle disableTypography className={classes.root} {...other}>
                <Typography variant="h6">{children}</Typography>
                {onClose ? (
                    <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
                        <CloseIcon/>
                    </IconButton>
                ) : null}
            </MuiDialogTitle>
        );
    });
    return (
        <Dialog onClose={handleClose} aria-labelledby="customized-dialog-title" open={openDialog}
                id="PersonalizedDialog">
            <DialogTitle id="customized-dialog-title" onClose={handleClose}>
                خروج از حساب کاربری
            </DialogTitle>

            {/*<section className="modalContent">
                <Box className="d-flex flex-column w-100">
                    <Lottie options={defaultOptions} height={200} width={200}/>
                </Box>
            </section>*/}

            <span className="text-center flex-grow-1">
                آیا از خروج خود اطمینان دارید؟!
            </span >
            <section className="modalFooter w-100">

                <button className="btn-confirm w-100" onClick={handleClose}
                >انصراف</button>

                <button className="btn-secondary w-100" style={{marginRight:'8px'}} onClick={_ => {
                    dispatch({
                        type: actionTypes.LOGOUT,
                        token: null,
                        loading: false,
                        role: []
                    })
                    removeUserRefreshToken()
                    removeUserToken()
                    navigate(RouteInfo.Login.globalUrl)
                    // changeDialogState()
                }
                } >
                    خروج
                </button>
            </section>

        </Dialog>
    )
}
export default Exit;